import { AppBar, makeStyles, Toolbar, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import CurrencySelect from "../CourrencySelect/CurrencySelect";

const useStyles = makeStyles({
  toolbarItem: {
    color: "#010101",
    margin: "10px",
    padding: "10px",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  currencyItem: {
    marginLeft: "auto",
  },
});

function Appbar({ currency }) {
  const classes = useStyles();
  return (
    <AppBar position="sticky">
      <Toolbar>
        <Typography
          component={Link}
          to="/"
          style={{ textDecoration: "none" }}
          className={classes.toolbarItem}
        >
          Coin
        </Typography>

        <Typography
          component={Link}
          to="/exchanges/"
          style={{ textDecoration: "none" }}
          className={classes.toolbarItem}
        >
          Exchanges
        </Typography>
        <Typography className={classes.currencyItem}>
          <CurrencySelect currency={currency} />
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default Appbar;
